import { canShowSketchPropertySection, handleSketchEntityPropertyConfirm, registerPropertyManagerSection } from '@/core';
import { SketchSplineCommand } from '@puppycad/cad-core';
import SplinePropertySection from '@/components/editor/property-manager/spline/SplinePropertySection.vue';

registerPropertyManagerSection({
  id: SketchSplineCommand.Spline,
  title: '样条曲线',
  order: 15,
  component: SplinePropertySection,
  actions: {
    confirm: true,
  },
  onConfirm: handleSketchEntityPropertyConfirm,
  isApplicable: (context) => canShowSketchPropertySection(context, context.splinePropertyVisible === true),
});
